export enum PreferencesParam {
  SIDEBAR_CLOSE = 'SIDEBAR_CLOSE',
  LANGUAGE = 'LANGUAGE',
  REMEMBER_ME = 'REMEMBER_ME',
}
